import * as d3 from 'd3';
import { ChromePicker,SwatchesPicker,GithubPicker,BlockPicker } from 'react-color';
import React, { useEffect, useRef, useState } from "react";
import ColorArray from "./ColorConstant";

const CustomizedColorPicker =({positionLeft, positionTop, originColor,showCallback})=>{
    const [curColor,setCurColor] = useState(originColor)

    var curX = 0
    var curY = positionTop

    // var ColorArray = ['#B80000', '#DB3E00', '#FCCB00', '#008B02',
    //     '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694',
    //     '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6',
    //     '#BED3F3', '#D4C4FB']

    function addAlpha(color, opacity) {

        // coerce values so ti is between 0 and 1.
        var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
        return color + _opacity.toString(16).toUpperCase();
    }

    initializePosition(positionLeft,positionTop)

    function initializePosition(x,y){
        // console.log(originColor)
        // console.log(addAlpha(originColor,0.5))
        var xOffset = -58
        var yOffset = 20
        // if (x + (width + margin * 2) > pickerWidth) {
        //     x_val = x - (width + margin * 2)
        // } else {
        //     x_val = x
        // }
        curX = x + xOffset
        curY = y + yOffset


    }



    function handleOnChange(oldColor,newColor){
        setCurColor(newColor)
        showCallback(oldColor,newColor)
    }


    // return (
    //     <div >
    //         {
    //             showColorPicker &&
    //             <div style={{position:'absolute',left:curX, top: curY}}>
    //                 {/*<ChromePicker*/}
    //                 {/*    color = {curColor}*/}
    //                 {/*    disableAlpha={true}*/}
    //                 {/*    onChangeComplete={c=>*/}
    //                 {/*    handleOnChange(curColor,c)*/}
    //                 {/*}*/}
    //                 {/*/>*/}
    //                 <BlockPicker
    //                     color = {originColor}
    //                     colors = {ColorArray}
    //                     triangle={"top"}
    //                     onChangeComplete={c=>
    //                         handleOnChange(curColor,c)
    //                     }
    //                 />
    //             </div>
    //         }
    //     </div>
    //
    // )
    return (

            <div style={{position:'absolute',left:curX, top: curY}}>
                {/*<ChromePicker*/}
                {/*    color = {curColor}*/}
                {/*    disableAlpha={true}*/}
                {/*    onChangeComplete={c=>*/}
                {/*    handleOnChange(curColor,c)*/}
                {/*}*/}
                {/*/>*/}
                <BlockPicker
                    color = {originColor}
                    colors = {ColorArray}
                    triangle={"top"}
                    onChangeComplete={c=>
                        handleOnChange(curColor,c)
                    }
                />
            </div>


    )
}

export default CustomizedColorPicker

